import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { store } from "src/store";
import { ClientActionEnum } from "src/store/reducers/client/types";
import { GlobalActionEnum } from "src/store/reducers/global/types";

const config: AxiosRequestConfig = {
  baseURL: `${process.env.REACT_APP_API}/client/`,
};
const instanceWithToken: AxiosInstance = axios.create(config);

instanceWithToken.interceptors.request.use((config) => {
  config.headers!.Authorization = `${localStorage.getItem("guest-token")}`;
  return config;
});

instanceWithToken.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("error", error);
    error.response.data === "Unauthorized"
      ? store.dispatch({
        type: ClientActionEnum.EXIT,
        result: error.response.data,
      })
      : store.dispatch({
        type: GlobalActionEnum.ERROR,
        result: error.response.data,
        status: error.response.status,
      });
  }
);

export default instanceWithToken;
